import { Tokens } from './tokens';

export class UserGroupTokenMapping{
    _id: string = "";
    group: string ="";
    tokens: Tokens[] = [new Tokens()];
    applicationName:Array<string>;

    constructor() { }
}